<template>
    <div class="height-percent-100">
        <div v-if="fixedInfo.map" class="height-percent-100">
            <div id="archMap"></div>
        </div>
        <div v-else class="border height-percent-100">
            <el-empty :description="$t('integration.monitoring_point_has_no_associated_map_unit')"></el-empty>
        </div>
    </div>
</template>
<script>
import { getLanguage } from '@/lang';
import { marker_arch } from '../../../../home/config/mapIcon';
import bus from '@/utils/bus';
export default {
    props: ['fixedInfo'],
    data() {
        return {
            flag: true,
            map: null
        };
    },
    watch: {
        fixedInfo: {
            immediate: true,
            handler() {
                const { map } = this.fixedInfo;
                if (map) this.getInitMap([map['longitude'], map['latitude']], false);
            }
        }
    },
    methods: {
        async getInitMap(center, isShowIcon) {
            // [AMap removed] await lazyAMapApiLoaderInstance.load();

            // [AMap removed] const map = new AMap.Map('archMap', {
            // [AMap removed]     lang: getLanguage().split('_')[0],
            // [AMap removed]     resizeEnable: true,
            // [AMap removed]     center: center || [113.43403, 23.173214],
            // [AMap removed]     zoom: 12,
            // [AMap removed]     viewMode: '3D' //使用3D视图
            // [AMap removed] });
            // 标记中心点
            // [AMap removed] if (!isShowIcon) {
            // [AMap removed]     let marker = new AMap.Marker({
            // [AMap removed]         position: center || [113.43403, 23.173214],
            // [AMap removed]         offset: new AMap.Pixel(-14, -31),
            // [AMap removed]         content: marker_arch
            // [AMap removed]     });
            // [AMap removed]     marker.setMap(map);
            // [AMap removed] }

            // [AMap removed] this.map = map;
        }
    },
    beforeDestory() {
        bus.$off('getCarrierNull');
    }
};
</script>

<style scoped lang="scss">
#archMap {
    width: 100%;
    height: 100%;
}
</style>
